import React from 'react';
import clsx from 'clsx';
import { firstResponseError } from '@/utils/errors';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import TaskRequestDialogContent from './TaskRequestDialogContent';
import Events from '../hooks/events';
import TaskRequestFormActions from './TaskRequestFormActions';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const TaskRequestDialog = ({ theme }) => {
  const {
    approved, name, readStatus, saveErrors,
  } = Selectors.useTaskRequestDialog();
  const hide = Events.useHideRequestTask();
  Fetch.useFetchActiveRequestTask({ readStatus });

  return (
    <DialogWrapper
      className={clsx('aridhia-task-request-dialog smallwizard')}
      error={firstResponseError(saveErrors)}
      icon="calendar check outline"
      onClose={hide}
      theme={theme}
      title={name}
      message={approved ? 'task.approved.text' : undefined}
      positive
      size="large"
      messageIcon="thumbs up"
    >
      <TaskRequestDialogContent />
      <TaskRequestFormActions />
    </DialogWrapper>
  );
};

export default TaskRequestDialog;
